import { render, staticRenderFns } from "./WarningPopComponent.vue?vue&type=template&id=3fa21c8b"
import script from "./WarningPopComponent.vue?vue&type=script&lang=js"
export * from "./WarningPopComponent.vue?vue&type=script&lang=js"
import style0 from "./WarningPopComponent.vue?vue&type=style&index=0&id=3fa21c8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports